import { AssessmentSliceActions } from "@assessment/store/slices/assessmentSlice";
import { encodeToBase64 } from "@lxp-app/utils/encodeImperva.ts";

export const extractPlainText = (html: string) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const paragraphs = Array.from(doc.querySelectorAll("p")).map(
    (p) => p.textContent?.trim() || ""
  );
  return paragraphs.join(" ");
};

const stripHtml = (html: string) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

export const createTextFile = (text: string, filename = "document.txt") => {
  const plainText = stripHtml(text);
  const blob = new Blob([plainText], { type: "text/plain" });
  const file = new File([blob], filename, { type: "text/plain" });
  return file;
};

export const uploadFileToSignedUrl = async (
  signedUrl: string,
  file: File,
  submissionUuid: string
  // showErrors: any
) => {
  try {
    const res = await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "text/plain",
        "x-goog-meta-submission-uuid": submissionUuid
      },
      body: file
    });
    if (!res.ok) {
      // if (showErrors)
      //   showErrors(
      //     "Submission Failed",
      //     [],
      //     "error",
      //     "Failed to submit the response. Please try again later!"
      //   );
      return;
    }

    // if (showErrors)
    //   showErrors(
    //     "Response Submitted",
    //     [],
    //     "success",
    //     "Successfully submitted the response."
    //   );

    return res;
  } catch (error: any) {
    // setIsSaving(false);
    // setIsChanged(true);
    // if (showErrors)
    //   showErrors(
    //     "Submission Failed",
    //     [],
    //     "error",
    //     "Failed to submit the response. Please try again later!"
    //   );
  }
};

export const saveAnswers = async (
  targetSection: any,
  activeQuestionMeta: any,
  responses: any,
  ongoingId: any,
  dispatch: any,
  saveSubjectiveApi: any,
  startQuestion: any,
  saveCodeAPi: any,
  attemptQuestion: any,
  responsesFib: any,
  isSubmit = false,
  handleModal?: () => void,
  switchQuestion?: () => void
) => {
  const currentQn = targetSection?.questions.filter(
    (el: any) => el.questionId == activeQuestionMeta?.questionId
  );
  const currentQnType = currentQn?.[0]?.type;
  if (currentQnType === "objective") {
    const IS_FIB_QUESTION = currentQn?.[0]?.subType == "fib";
    const candidateResponseForQuestion = activeQuestionMeta?.questionId
      ? IS_FIB_QUESTION
        ? responsesFib[activeQuestionMeta.questionId!]
        : responses[activeQuestionMeta.questionId!]
      : undefined;
    if (
      candidateResponseForQuestion === undefined ||
      candidateResponseForQuestion === null ||
      (Array.isArray(candidateResponseForQuestion) &&
        [...candidateResponseForQuestion].length === 0)
    ) {
      switchQuestion && switchQuestion();
      return;
    }
    try {
      if (!ongoingId) {
        throw {
          status: "",
          title: "Ongoing Id Not Found",
          err: {},
          description: ""
        };
      }

      const newAnswer =
        candidateResponseForQuestion !== undefined
          ? candidateResponseForQuestion
          : IS_FIB_QUESTION
            ? {}
            : [];

      const prefixedFibAnswer =
        typeof newAnswer === "object" && newAnswer !== null
          ? Object.fromEntries(
              Object.entries(newAnswer as Record<string, string>).map(
                ([k, v]) => [`&${k}`, v]
              )
            )
          : newAnswer;

      const reqBody = IS_FIB_QUESTION
        ? {
            userSolutions: null,
            userFibSolutions: encodeToBase64(JSON.stringify(prefixedFibAnswer))
          }
        : {
            userSolutions: newAnswer,
            userFibSolutions: null
          };
      const res = await attemptQuestion({
        questionId: activeQuestionMeta?.questionId as string,
        ongoingId: ongoingId,
        body: reqBody
      });
      if (res.error) {
        throw {
          status: "",
          title: "Failed to attempt the question",
          err: res.error,
          description: ""
        };
      }
      if (res?.data?.data?.ongoingQpDuration) {
        dispatch(
          AssessmentSliceActions.mutateTimeLeft(
            res?.data?.data?.ongoingQpDuration
          )
        );
      }

      const res2 = await startQuestion({
        actionType: "completed",
        ongoingId: ongoingId,
        questionId: activeQuestionMeta?.questionId as string
      });

      if (res2.error) {
        throw {
          status: "",
          title: "Failed to complete the question",
          err: res2.error,
          description: ""
        };
      }

      dispatch(
        AssessmentSliceActions.mutateQuestionProgress({
          questionId: activeQuestionMeta?.questionId as string,
          sectionId: activeQuestionMeta.sectionId,
          status: "completed"
        })
      );
    } catch (err) {
      console.error(err);
      const temp: any = err;
      const rawErrList = temp?.err?.data?.error;
      const errList =
        rawErrList?.length > 0
          ? rawErrList?.map((el: string) => el.split("_")[0])
          : [];
    }
    switchQuestion && switchQuestion();
  } else if (currentQnType === "subjective") {
    if (currentQn?.[0]?.submissionType?.[0] === "video") {
      if (responses[activeQuestionMeta.questionId!]?.length > 0) {
        handleModal && handleModal();
      } else switchQuestion && switchQuestion();
    } else {
      const subjectiveCandidateRes = activeQuestionMeta?.questionId
        ? responses[activeQuestionMeta.questionId!]
        : undefined;

      const typedText = extractPlainText(
        subjectiveCandidateRes?.value || ""
      ).trim();
      if (typedText.length > 0) {
        if (typedText.split(/\s+/).filter(Boolean).length < 40)
          handleModal && handleModal();
        else {
          try {
            dispatch(AssessmentSliceActions.mutateSaving(true));
            const res: any = await saveSubjectiveApi({
              ongoingId: ongoingId ?? "",
              questionId: activeQuestionMeta?.questionId as string,
              quesVersion: subjectiveCandidateRes?.version ?? 1,
              body: {
                solution: btoa(
                  unescape(encodeURIComponent(subjectiveCandidateRes?.value))
                ),
                uploadConfigId: subjectiveCandidateRes?.uploadConfigId,
                fileDetails: {
                  fileName: "subjective",
                  fileSize: 10,
                  fileExtension: ".txt",
                  filePath: "string"
                }
              }
            });
            if (res?.data?.data?.uploadUrlDetails?.data) {
              const uploadConfig = res?.data?.data?.uploadUrlDetails?.data;
              const textFile = createTextFile(
                subjectiveCandidateRes?.value || ""
              );
              dispatch(
                AssessmentSliceActions.mutateCandidateResponse({
                  questionId: activeQuestionMeta?.questionId as string,
                  answerKey: []
                })
              );
              if (textFile) {
                uploadFileToSignedUrl(
                  uploadConfig?.upload_url,
                  textFile,
                  uploadConfig?.submission_uuid
                )
                  .then(() => {
                    dispatch(
                      AssessmentSliceActions.mutateQuestionProgress({
                        questionId: activeQuestionMeta?.questionId!,
                        sectionId: activeQuestionMeta?.sectionId!,
                        status: "completed"
                      })
                    );
                    dispatch(
                      AssessmentSliceActions.mutateCandidateResponse({
                        questionId: activeQuestionMeta?.questionId!,
                        answerKey: []
                      })
                    );
                    dispatch(AssessmentSliceActions.mutateSaving(false));
                    switchQuestion && switchQuestion();
                  })
                  .catch((error: any) => {
                    dispatch(AssessmentSliceActions.mutateSaving(false));
                    switchQuestion && switchQuestion();
                  });
              }
            } else {
              dispatch(AssessmentSliceActions.mutateSaving(false));
            }
          } catch (error: any) {
            dispatch(AssessmentSliceActions.mutateSaving(false));
            console.log("error", error);
          }
        }
      } else switchQuestion && switchQuestion();
    }
  } else {
    const codingCandidateRes = activeQuestionMeta?.questionId
      ? responses[activeQuestionMeta.questionId!]
      : undefined;
    if (
      codingCandidateRes &&
      codingCandidateRes?.[0] != undefined &&
      codingCandidateRes?.[0]?.["value"]
    ) {
      try {
        const res: any = await saveCodeAPi({
          ongoingId: ongoingId || "",
          questionId: activeQuestionMeta?.questionId!,
          quesVersion: codingCandidateRes?.[0]?.["qnVersion"],
          body: codingCandidateRes?.[0]?.["value"]
        });
        if (res?.data?.error?.length == 0) {
          if (res?.data?.data?.ongoingQpDuration) {
            dispatch(
              AssessmentSliceActions.mutateTimeLeft(
                res?.data?.data?.ongoingQpDuration
              )
            );
          }
          dispatch(
            AssessmentSliceActions.mutateCandidateResponse({
              questionId: activeQuestionMeta?.questionId!,
              answerKey: []
            })
          );
        }

        if (isSubmit) {
          const res2 = await startQuestion({
            actionType: "completed",
            ongoingId: ongoingId ?? "",
            questionId: activeQuestionMeta?.questionId!
          });

          if (res2.error) {
            throw {
              status: "",
              title: "Failed to complete the question",
              err: res2.error,
              description: ""
            };
          }
          dispatch(
            AssessmentSliceActions.mutateQuestionProgress({
              questionId: activeQuestionMeta?.questionId!,
              sectionId: activeQuestionMeta?.sectionId!,
              status: "completed"
            })
          );
          dispatch(
            AssessmentSliceActions.mutateCandidateResponse({
              questionId: activeQuestionMeta?.questionId!,
              answerKey: []
            })
          );
        }
      } catch (error) {
        console.log("error", error);
      }
    }
    switchQuestion && switchQuestion();
  }
  return;
};
